import React from 'react';
import { translate } from '../../../Controller/3DController/translateController';
import ToggleSwitch from '../../ToggleSwitch';
import { Mobile, Tap } from '../Icons/Icons';

import './CarPlacementOverlay.scss';

export interface CarPlacementOverlayProps {
    text: string;
    type?: 'place' | 'scan';
    toggleActive?: boolean;
    toggleOnChange?: () => any;
}

const CarPlacementOverlay: React.FC<CarPlacementOverlayProps> = ({ 
    text,
    type = 'place',
    toggleActive = false,
    toggleOnChange = () => {},
    ...props
}) => {
    return (
        <div className="vw-car-placement-overlay" {...props}>
            <div className={`vw-car-placement-overlay__${type === 'scan' ? 'scan' : 'hand'}`}>
                {type === 'scan' ? <Mobile /> : <Tap />}
            </div>

            <ToggleSwitch
                isActive={toggleActive}
                onToggle={toggleOnChange}
                activeLabel={translate("id_xr_scale_1_to_1")}
                inactiveLabel={translate("id_xr_scale_table")}
                style={{ bottom: type === 'place' ? '45px' : undefined }}
            />

            <div className="vw-car-placement-overlay__text">
                {text}
            </div>
        </div>
    );
};

export default CarPlacementOverlay;
